import { CustomInputNumber } from '@app/components/CustomInputNumber/CustomInputNumber.main';

export { CustomInputNumber };
